import moment from "moment"
import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import api from "../../api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import DateRangePickerCustom from "../../components/Common/DateRangePicker/DateRangePickerCustom"
import { GLOBAL_CONSTANTS } from "../../constants/constants"
import { RootState } from "../../store"
import {
    loadMarkReasons,
    loadParcelDestinations,
    loadParcelPercentageById,
    loadParcels,
    loadParcelsById,
    loadParcelStatuses
} from "../../store/parcel.store"
import { arrayOfObjectsToObject } from "../../utils/commonFunctions"
import Header from "../Layout/Header"
import AddParcelModal from "./AddParcelModal"
import AddressChangeModal from "./AddressChangeModal"
import EditParcel from "./EditParcel"
import MarkAsException from "./MarkAsExceptionModal"
import ParcelsTable from "./ParcelsTable"
import SplitParcelsModal from "./SplitParcelsModal"

const Parcels = () => {
    const dispatch = useAppDispatch()
    //Date Picker Logic
    const { t } = useTranslation()
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { parcels, loading, exceptionReasons, parcelDestinations, parcelStatus } = useAppSelector(
        (state: RootState) => state.parcels
    )
    const { parcelCustomers: customers, loading: customersLoading } = useAppSelector(
        (state: RootState) => state.customers
    )
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)
    //Date Picker Logic
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [show, setShow] = useState("")
    // const [editshow, setEditShow] = useState(false);
    // const [addressChange, setAddressChangeShow] = useState(false);
    // const [markExceptionShow, setMarkExceptionShow] = useState(false);
    const [parcelData, setParcelData] = useState({} as Record<string, any>)
    const [editId, setEditId] = useState(0)
    const [page, setpage] = useState(GLOBAL_CONSTANTS.PAGE)
    const [pageSize, setPageSize] = useState(GLOBAL_CONSTANTS.PAGE_SIZE)
    const [reqLoading, setReqLoading] = useState(false)
    const [CustomerList, setCustomerList] = useState([] as Record<string, any>)
    const [StatusList, setStatusList] = useState([] as Record<string, any>)
    const [parcelSearch, setParcelSearch] = useState({
        uuid: "",
        customer: "",
        country: "",
        suite: "",
        status: {
            value: "",
            label: ""
        },
        date: "",
        split: "",
        deleted: ""
    })
    const [firstLoad, setFirstLoad] = useState(false)

    const defaultWarehouse = userInfo?.ParcelHubUserWarehouse?.find(
        (uw: Record<string, any>) => uw?.is_default
    )?.warehouse_id

    const handleClose = () => {
        setShow("")
        setParcelData({})
        dispatch(loadParcelDestinations())
        dispatch(loadParcelStatuses())
        dispatch(loadParcels({ page, pageSize, warehouse: selectedWarehouse?.toString(), parcelSearch }))
    }

    const handleShow = (modalName: string, data?: Record<string, any>) => {
        let parcelData = data || {}
        if (modalName === "editParcel") {
            dispatch(loadParcelsById({ uuid: parcelData.uuid }))
            dispatch(loadParcelPercentageById({ id: parcelData.id }))
            setEditId(parcelData.uuid)
        } else {
            setParcelData(parcelData)
        }
        setShow(modalName)
    }

    const onDeleteParcelClick = async (parcelId: number) => {
        try {
            const res = await api.parcel.deleteParcel(parcelId).then((res) => {
                if (res.status) {
                    dispatch(
                        loadParcels({ page, pageSize, warehouse: selectedWarehouse?.toString(), parcelSearch })
                    )
                }
            })
        } catch (error) {
            console.error(error)
        }
    }

    const tableDataChange = (page: number, page_size: number) => {
        setpage(page)
        setPageSize(page_size)
    }

    const handleSplitParcels = async (data: Record<string, any>[]) => {
        try {
            setReqLoading(true)
            const reqBody = {
                parcelId: parcelData?.id,
                newParcels: { ...arrayOfObjectsToObject(data) }
            }
            const res = await api.parcel.splitParcels(reqBody)
            if (res?.data?.status) {
                if (res?.data?.payload?.label) {
                    const barcodeLink = document.createElement("a") as HTMLAnchorElement
                    barcodeLink.className = "d-none"
                    barcodeLink.href = res?.data?.payload?.label || ""
                    barcodeLink.target = "_blank"
                    barcodeLink.click()
                }
                dispatch(loadParcelDestinations())
                dispatch(loadParcelStatuses())
                dispatch(
                    loadParcels({ page, pageSize, warehouse: selectedWarehouse?.toString(), parcelSearch })
                )
            }
            setReqLoading(false)
        } catch (error) {
            console.error(error)
            setReqLoading(false)
        }
    }

    const onSearchClick = () => {
        if (selectedWarehouse) {
            dispatch(loadParcels({ page, pageSize, warehouse: selectedWarehouse?.toString(), parcelSearch }))
        }
    }

    useEffect(() => {
        let statusData = parcelStatus?.map((status: any) => ({
            value: status.id,
            label: status?.name
        }))

        statusData = [
            ...statusData,
            {
                value: "split",
                label: "Split Parcels"
            },
            {
                value: "notsplit",
                label: "Non Split Parcels"
            },
            {
                value: "deleted",
                label: "Removed Parcels"
            },
            {
                value: "notdeleted",
                label: "Existing Parcels"
            }
        ]
        setStatusList(statusData)
    }, [parcelStatus])

    useEffect(() => {
        const dateObj =
            startDate && endDate
                ? moment(startDate).format("YYYY-MM-DD") + "|" + moment(endDate).format("YYYY-MM-DD")
                : ""
        setParcelSearch({ ...parcelSearch, date: dateObj })
    }, [endDate])

    useEffect(() => {
        // dispatch(loadParcelDestinations())
        // dispatch(loadParcelStatuses())
        // dispatch(loadMarkReasons())
        // dispatch(itemsAutocomplete(""))
        // dispatch(supplierAutocomplete({}))
    }, [])

    useEffect(() => {
        if (selectedWarehouse && selectedWarehouse !== 0) {
            // dispatch(loadCustomers({warehouse: selectedWarehouse?.toString()}))
            dispatch(
                loadParcels({ page, pageSize, warehouse: selectedWarehouse?.toString(), parcelSearch })
            ).then(() => {
                if (!firstLoad) {
                    dispatch(loadParcelDestinations())
                    dispatch(loadParcelStatuses())
                    dispatch(loadMarkReasons())
                }
                setFirstLoad(true)
            })
        }
    }, [parcelSearch.date, selectedWarehouse, page, pageSize])

    const [file, setFile] = useState("")

    const uploadFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault()
        const formData = new FormData()
        formData.append("file", file)
        try {
            const res = await api.parcel.uploadFile(formData)
            if (res.status) {
                alert("File uploaded successfully")
                dispatch(
                    loadParcels({ page, pageSize, warehouse: selectedWarehouse?.toString(), parcelSearch })
                )
            }
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <>
            <div className="parcels">
                <Header
                    title="Parcels"
                    records={parcels?.total}
                    data={parcels?.parcels}
                    name="Parcels"
                    buttonId=".parcelExportButton">
                    <div className={"mx-4"}>
                        <input type="file" onChange={(e) => setFile(e.target.files[0])} name="file" />
                        <button className={"btn btn-primary"} onClick={uploadFile} disabled={!file}>
                            Upload
                        </button>
                    </div>

                    <div className="mx-2">
                        <DateRangePickerCustom
                            setStartDate={setStartDate}
                            setEndDate={setEndDate}
                            startDate={startDate}
                            endDate={endDate}
                        />
                    </div>
                </Header>

                <div className="row justify-content-end px-4 mt-3">
                    <Button
                        className="col-lg-2 col-md-4 col-sm-12 col-12 "
                        onClick={() => handleShow("receiveParcel")}>
                        {t("Receive Parcel")}
                    </Button>
                </div>
                {loading || customersLoading || !userInfo?.accessToken ? (
                    <div className="loader row justify-content-center">
                        <ScaleLoader color="#15397F" width={4} height={40} />
                    </div>
                ) : (
                    <div className="row d-flex">
                        <ParcelsTable
                            parcels={parcels}
                            tableDataChange={tableDataChange}
                            parcelSearch={parcelSearch}
                            setParcelSearch={setParcelSearch}
                            onSearchClick={onSearchClick}
                            handleShow={handleShow}
                            parcelDestinations={parcelDestinations}
                            parcelStatus={StatusList}
                            onDeleteParcelClick={onDeleteParcelClick}
                        />
                    </div>
                )}
                <AddParcelModal show={show} handleClose={handleClose} customers={customers} />
                <EditParcel show={show} handleClose={handleClose} id={editId} />
                <AddressChangeModal show={show} handleClose={handleClose} data={parcelData} />
                <MarkAsException
                    show={show}
                    handleClose={handleClose}
                    data={parcelData}
                    exceptionReasons={exceptionReasons}
                />
                <SplitParcelsModal
                    show={show}
                    setShow={setShow}
                    handleClose={handleClose}
                    data={parcelData}
                    handleSubmit={handleSplitParcels}
                    loading={reqLoading}
                />
            </div>
        </>
    )
}

export default Parcels
